const CATALOG_HUB_PATHS = new Set([
  'sale/catalog',
  'sale/catalog/phuket',
  'sale/catalog/samui',
  'rent/catalog',
  'rent/catalog/phuket',
  'rent/catalog/samui',
]);

const LOCALES = new Set(['ru', 'en']);

export const isCatalogHubPath = (asPath: string, language?: string) => {
  const path = asPath.split(/[?#]/)[0] ?? '';
  const segments = path.split('/').filter(Boolean);
  const [first] = segments;
  if (first && (first === language || LOCALES.has(first))) {
    segments.shift();
  }
  return CATALOG_HUB_PATHS.has(segments.join('/'));
};
